export default {"src":"/_next/static/media/tag.1a9a9b3f.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};